import './alert-container.scss'

import { defineComponent } from 'vue';

import { ConditionReportRoutes } from '@skinsoft/const';
import { reactiveVueMixin } from '@skinsoft/reactive-vue';

export const AlertContainer = defineComponent({
    mixins: [reactiveVueMixin],
    template: require('./alert-container.html'),
    data() {
        return {
            alertMessage: "",
            alertVariant: "",
            show: false,
            saveAlertTimeout: null as any,
            offsetBottom: false,
        }
    },
    mounted() {
        this.subscribeToBus('display-alert-topic', (message) => {
            if (message.payload) {
                this.showAlert(message.payload)
            }
        })
    },
    methods: {
        showAlert(alertData: any) {
            const SAVE_ALERT_DURATION = 3000
            clearTimeout(this.saveAlertTimeout)
            this.show = false;
            this.alertMessage = alertData.message;
            this.alertVariant = alertData.variant;
            setTimeout(() => {
                this.show = true;
                this.saveAlertTimeout = setTimeout(() => {
                    this.show = false;
                },
                    SAVE_ALERT_DURATION)
            }, 200);
        },
    },
    watch: {
        'router.currentRoute': {
            handler() {
                this.offsetBottom = this.$router.currentRoute.value.name === ConditionReportRoutes.EDIT_REPORT;
            },
            deep: true,
        },
    },
})
